const cities = [
  { name: "Ponte Vedra Beach", zips: "32082" },
  { name: "Jacksonville Beach", zips: "32250" },
  { name: "Atlantic Beach", zips: "32233" },
  { name: "Neptune Beach", zips: "32266" },
  { name: "St. Augustine", zips: "32084, 32080" },
  { name: "Palm Valley", zips: "32082" },
  { name: "Nocatee", zips: "32081" },
  { name: "Julington Creek", zips: "32259" },
];

const benefits = [
  {
    icon: "ri-computer-line",
    title: "Start 100% Online",
    desc: "No office visit required to begin. Complete your order from home, the golf course, or Sawgrass Village in minutes.",
  },
  {
    icon: "ri-truck-line",
    title: "Ship Your Documents",
    desc: "Use overnight shipping to send your documents directly to us — we handle the rest.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Expert Document Review",
    desc: "Every application is reviewed by our team before submission to reduce errors and delays.",
  },
  {
    icon: "ri-calendar-check-line",
    title: "Reserved Agency Access",
    desc: "We hold reserved submission slots at the regional passport agency — no public appointment needed.",
  },
];

export default function PonteVedraBeachLocalAreaSection() {
  return (
    <section id="service-area" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Service Area</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Serving Ponte Vedra Beach &amp; Coastal Northeast Florida
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Whether you are in Ponte Vedra Beach, Jacksonville Beach, St. Augustine, Nocatee, or anywhere along coastal St. Johns County, Fast Passport Center makes expedited passport processing simple — no drive to a passport agency, no agency lines, no guessing.
          </p>
        </div>

        {/* Full-width editorial intro */}
        <div className="bg-white rounded-lg border border-gray-200 p-6 md:p-8 mb-12">
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            Ponte Vedra Beach is not a typical Florida coastal town. Where most beach communities evolved around tourism, retirement, or seasonal migration, Ponte Vedra Beach was deliberately conceived as an exclusive, planned residential and resort community rooted in world-class golf and coastal elegance. Located in St. Johns County along a stunning stretch of Atlantic coastline, this unincorporated community of roughly 30,000 residents is best known as the home of TPC Sawgrass — the legendary golf course that hosts The Players Championship every March, often called the "fifth major" in professional golf. The PGA Tour headquarters sits here, and the Stadium Course's island-green 17th hole is among the most photographed holes in golf history.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            But Ponte Vedra Beach is far more than golf. The Ponte Vedra Inn &amp; Club — established in 1928 — is one of Florida's most prestigious luxury resorts, drawing affluent families, corporate retreats, and destination weddings from across the country and abroad. Sawgrass Village serves as the upscale retail and dining heart of the community, while the residential neighborhoods range from oceanfront estates along Ponte Vedra Boulevard to golf course homes within walking distance of TPC Sawgrass. The community maintains an unusually high median household income and an educated, professional demographic that includes executives, medical professionals affiliated with nearby Mayo Clinic in Jacksonville, attorneys, financial advisors, and golf industry professionals.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            What distinguishes Ponte Vedra Beach's travel patterns is the intersection of golf tourism, medical travel, family affluence, and seasonal coastal living. Golf professionals and enthusiasts travel to Scotland, Ireland, and Pebble Beach for championship play and bucket-list rounds. Mayo Clinic Jacksonville patients and medical conference attendees fly to London, Zurich, and Singapore for specialized consultations and international medical conferences. Affluent families vacation in the Caribbean, Europe, and Latin America during school breaks. Seasonal residents — many from the Northeast and Midwest — maintain dual residences and discover passport issues when transitioning between their Ponte Vedra Beach winter home and international summer travel.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            The geographic reality of Ponte Vedra Beach matters for passport services. Jacksonville International Airport (JAX) sits approximately 30 miles north via I-95 or A1A — a 35–45 minute drive under normal conditions. While JAX is a well-run, efficient airport with direct international service, there is no regional passport agency in Jacksonville or anywhere nearby. The closest regional passport agency is in Miami, approximately 350 miles south — a drive of over five hours or a flight connection away. For a Ponte Vedra Beach golfer who discovers an expired passport a week before a Scotland golf trip, or a Mayo Clinic physician with a last-minute medical conference in London, the absence of a nearby passport agency makes standard expedited processing impossible without a registered courier service.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed">
            Fast Passport Center has processed expedited passports for Ponte Vedra Beach travelers across every demographic — golf groups, medical professionals, resort families, and seasonal residents. Our courier-based expedited service means you start online from your Ponte Vedra Beach home, your Sawgrass office, or your club — and your passport arrives within days, not months, with no drive to Miami required.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          {/* Left — FPC Office + How It Works */}
          <div>
            {/* FPC Office Card */}
            <div className="bg-[#1A365D] rounded-lg p-7 mb-8 text-white">
              <div className="flex items-center gap-3 mb-5">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#F6C344] flex-shrink-0">
                  <i className="ri-building-2-line text-[#1A365D] text-xl"></i>
                </div>
                <div>
                  <p className="font-bold text-base">Fast Passport Center — Delray Beach</p>
                  <p className="text-white/60 text-xs mt-0.5">401 W Atlantic Ave #351, Delray Beach, FL 33444</p>
                </div>
              </div>
              <p className="text-white/70 text-sm mb-1">
                <i className="ri-map-pin-line text-[#F6C344] mr-1.5"></i>
                Serving Ponte Vedra Beach — courier pickup available throughout Northeast Florida
              </p>
              <p className="text-white/50 text-xs mb-5 ml-5">Most clients ship overnight — no office visit required</p>
              <div className="border-t border-white/10 pt-5">
                <p className="text-white/80 text-sm leading-relaxed mb-4">
                  After signing up online, choose what works best for you: <strong className="text-white">courier pickup</strong> from your Ponte Vedra Beach home or office in most cases, <strong className="text-white">ship with our prepaid label</strong> from any UPS/FedEx location, or <strong className="text-white">schedule a drop-off</strong> at our Delray Beach office. Most clients ship overnight — no visit required.
                </p>
                <a
                  href="https://fastpassportcenter.com/checkout/"
                  className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-5 py-2.5 rounded-md transition-all whitespace-nowrap"
                >
                  Start My Passport <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>

            {/* How FPC Helps */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {benefits.map((b, i) => (
                <div key={i} className="bg-white rounded-lg p-5 border border-gray-200">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#F6C344]/15 mb-3">
                    <i className={`${b.icon} text-[#1A365D] text-base`}></i>
                  </div>
                  <p className="font-bold text-[#1A365D] text-sm mb-1">{b.title}</p>
                  <p className="text-gray-500 text-xs leading-relaxed">{b.desc}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Right — Cities We Serve + Trust strip */}
          <div>
            <div className="bg-white rounded-lg p-7 mb-6 border border-gray-200">
              <h3 className="font-bold text-[#1A365D] text-sm uppercase tracking-wide mb-5">
                <i className="ri-map-pin-2-line text-[#F6C344] mr-2"></i>
                Cities &amp; Communities We Serve
              </h3>
              <div className="space-y-1.5">
                {cities.map((city, i) => (
                  <div
                    key={i}
                    className="flex items-center justify-between py-2.5 px-3 bg-[#F7F8FA] rounded-md"
                  >
                    <div className="flex items-center gap-2.5">
                      <i className="ri-checkbox-circle-fill text-[#F6C344] text-sm"></i>
                      <span className="text-[#1A365D] font-medium text-sm">{city.name}</span>
                    </div>
                    {city.zips && (
                      <span className="text-gray-400 text-xs font-mono">{city.zips}</span>
                    )}
                  </div>
                ))}
              </div>
              <p className="text-gray-500 text-xs mt-4 leading-relaxed">
                Anywhere in coastal St. Johns, Duval, and Flagler Counties — start online, ship overnight, and we handle the rest. No need to drive to Miami.
              </p>
            </div>

            {/* Internal links */}
            <div className="bg-white rounded-lg p-5 mb-6 border border-gray-200">
              <p className="text-gray-400 text-xs font-semibold uppercase tracking-widest mb-3">Nearby Cities We Serve</p>
              <div className="flex flex-wrap gap-2">
                {[
                  { name: "Jacksonville", href: "/jacksonville" },
                  { name: "Tallahassee", href: "/tallahassee" },
                  { name: "Orlando", href: "/orlando" },
                  { name: "Daytona Beach", href: "/states/florida" },
                  { name: "St. Augustine", href: "/states/florida" },
                  { name: "Tampa", href: "/tampa" },
                ].map((link) => (
                  <a
                    key={link.href}
                    href={link.href}
                    className="inline-flex items-center gap-1 text-xs text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors bg-[#F7F8FA] border border-gray-200 hover:border-[#F6C344] rounded-full px-3 py-1.5 whitespace-nowrap"
                  >
                    {link.name} <i className="ri-arrow-right-line text-[10px]"></i>
                  </a>
                ))}
              </div>
            </div>

            {/* Trust credentials strip */}
            <div className="bg-[#1A365D] rounded-lg p-5">
              <p className="text-white/50 text-xs uppercase tracking-widest font-semibold mb-4">Why Travelers Choose Fast Passport Center</p>
              <div className="grid grid-cols-2 gap-3">
                {[
                  { icon: "ri-government-line", value: "Registered Courier", label: "U.S. Department of State" },
                  { icon: "ri-award-line", value: "A+ Rating", label: "Better Business Bureau" },
                  { icon: "ri-calendar-check-line", value: "20+ Years", label: "Serving Travelers Nationwide" },
                  { icon: "ri-customer-service-2-line", value: "Real Humans", label: "Live Support — Not a Bot" },
                ].map((item, i) => (
                  <a
                    key={i}
                    href="https://fastpassportcenter.com"
                    className="flex items-center gap-2.5 bg-white/5 hover:bg-white/10 rounded-md px-3 py-2.5 transition-colors cursor-pointer"
                  >
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#F6C344]/15 flex-shrink-0">
                      <i className={`${item.icon} text-sm text-[#F6C344]`}></i>
                    </div>
                    <div className="text-left">
                      <span className="text-white text-xs font-bold block leading-tight">{item.value}</span>
                      <span className="text-white/50 text-xs leading-tight block">{item.label}</span>
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}